// import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import store from '../store/index'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/HomeView',
  },
  {
    path: '/HomeView',
    name: 'HomeView',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/HoldList',
    name: 'HoldList',
    component: () => import('../views/HoldList.vue')
  },
  {
    path: '/HistoryList',
    name: 'HistoryList',
    component: () => import('../views/HistoryList.vue')
  },
  {
    path: '/LoginView',
    name: 'LoginView',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/PropertyView',
    name: 'PropertyView',
    component: () => import('../views/PropertyView.vue')
  },
  {
    path: '/ManageView',
    name: 'ManageView',
    component: () => import('../views/ManageView.vue')
  },
  {
    path: '/AlgorithmView',
    name: 'AlgorithmView',
    component: () => import('../views/AlgorithmView.vue')
  },
  {
    path: '/ThreeDCharts',
    name: 'ThreeDCharts',
    component: () => import('../views/ThreeDCharts.vue')
  },
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('getToken')
  const token = store.state.token
  // console.log('token:',token);
  if (!token && to.name !== 'LoginView') {
      next({ name: 'LoginView' })
  } else {
      next()
  }
  // next()
})

export default router
